// Establish CSS cascade layer order before any other styles load.
// Spectrum S2 uses @layer _, so _ must be declared last for highest priority.
// This must be the first import in index.jsx to ensure the layer order is
// established before Vite injects any S2 component CSS <style> tags.
const style = document.createElement('style');
style.textContent = '@layer theme, base, components, utilities, _;';
document.head.prepend(style);
